<template>
  <div>
    <div v-show="conShow">
      <div>
        <headMenu @showApply="showApply"></headMenu>
      </div>
      <div class="set-bgc">
        <div class="set-img">
          <img style="width: 50%" src="../assets/cp/cp-head-xing.png" alt="">
          <div class="con1-title">
            <span style="color: #2D2D2D">论文检测</span>
            <span style="color: #DC4900">首选</span>
            <span style="color: #005CE5">格子达</span>
          </div>
          <div>
            <img style="width: 75%;margin-top: 4%;" src="../assets/home-i.png" alt="">
          </div>
<!--          <div class="cp-icon">-->
<!--            <div class="setImg">助学</div>-->
<!--            <div class="setImg">助管</div>-->
<!--            <div class="setImg">助研</div>-->
<!--          </div>-->
        </div>
        <div @click="lookDetails(1)" class="cp-tab">
          <div class="cp-set-img">
            <img style="width: 100%" src="../assets/cp/cp-img1.png" alt="">
          </div>
          <div style="text-align: left">
            <div class="cp-tab-title">论文查重</div>
            <div class="co-tab-text">全方位发现学术不端行为</div>
          </div>
        </div >
        <div @click="lookDetails(2)" class="cp-tab">
          <div class="cp-set-img">
            <img style="width: 100%" src="../assets/cp/cp-img2.png" alt="">
          </div>
          <div style="text-align: left">
            <div class="cp-tab-title">格式检测</div>
            <div class="co-tab-text">按国标与学校要求检测</div>
          </div>
        </div>
        <div @click="lookDetails(3)" class="cp-tab">
          <div class="cp-set-img">
            <img style="width: 100%" src="../assets/cp/cp-img3.png" alt="">
          </div>
          <div style="text-align: left">
            <div class="cp-tab-title">毕设（论文）管理系统</div>
            <div class="co-tab-text">按需定制本校毕设方案</div>
          </div>
        </div>
        <div @click="lookDetails(4)" class="cp-tab">
          <div class="cp-set-img">
            <img style="width: 100%" src="../assets/cp/cp-img4.png" alt="">
          </div>
          <div style="text-align: left">
            <div class="cp-tab-title">论文抽检</div>
            <div class="co-tab-text">按教育部抽检框架预送审</div>
          </div>
        </div>
      </div>
    </div>
    <applyDetails ref="apply" @returnPage="returnPage"></applyDetails>
    <productDetails ref="pro" @returnPage="returnPage"></productDetails>
  </div>
</template>

<script>
import headMenu from "@/head/headMenu.vue";
import applyDetails from "@/head/components/applyDetails.vue";
import productDetails from "@/views/components/productDetails.vue";

export default {
  name: "product",
  components: {applyDetails, headMenu, productDetails},
  data() {
    return {
      conShow: true,
    }
  },
  mounted() {
    this.conShow = true
  },
  methods:{
    showApply() {
      this.conShow = false
      this.$refs.apply.init()
    },
    returnPage(){
      this.conShow = true
    },
    lookDetails(type){
      this.conShow = false
      this.$refs.pro.init(type)
    },
  }
}
</script>

<style scoped>
.set-bgc{
    background: #F5F7F9;
    height: 750px;
}
.cp-tab{
    width: 90%;
    height: 100px;
    background: #FFFFFF;
    box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.08);
    border-radius: 15px;
    position: relative;
    margin: auto;
    left: 0;
    right: 0;
    top: 20px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
}
.cp-set-img{
    width: 66px;
    height: 66px;
    margin-right: 15px;
    margin-left: 15px;
}
.cp-tab-title{
    font-size: 18px;
    font-weight: bold;
    color: #333333;
    justify-content: center;
}
.co-tab-text{
    font-size: 15px;
    font-weight: 400;
    color: #666666;
}
.cp-icon{
    display: flex;
    height: 70px;
}
.con1-title{
    font-weight: bold;
    font-size: 32px;
    height: 50px;
    padding-top: 2%;
    text-shadow: 0px 2px 4px #FFFFFF;
}
.set-img{
    background: url("../assets/cp/cp-headImg.png") no-repeat;
    background-size: 100% 100%;
    padding-top: 20px;
}
.setImg{
    background: url("../assets/home-icon.png") no-repeat;
    background-size: 100%;
    height: 100px;
    min-width: 70px;
    margin: 28px;
    color: #0445E0;
    font-size: 21px;
    line-height: 0px;
}
</style>